@if (canBulkUpload) {
  <mc-button
    label="Bulk Upload"
    variant="filled"
    appearance="primary"
    fit="small"
    (click)="uploadDialog()"
    (keydown.enter)="uploadDialog()"
    (keydown.space)="$event.preventDefault(); uploadDialog()"></mc-button>

  <mc-modal backdropcloseactiondisabled heading="Upload File" [open]="openUploadDialog" (closed)="closeUploadDialog()">
    <p class="upload-format-hint" i18n>Only .xlsx format allowed.</p>

    <mc-file-upload
      class="mc-file-upload_drag-drop"
      variant="drag-drop"
      name="files"
      accept=".xlsx"
      hiddenlegend
      allowduplicatefilenames
      [invalid]="!!fileErrorMessage"
      [errormessage]="fileErrorMessage"
      (input)="onFileChange($event)"
      (invalidfile)="onInvalidFile()"></mc-file-upload>

    @if (fileErrors.length > 0) {
      <div class="m-t-16">
        <mc-notification appearance="error" fit="small" icon="exclamation-circle">
          <div>
            <span i18n>The file was not processed.</span>
            <ul class="file-error-list">
              @for (fileError of fileErrors; track fileError) {
                <li>{{ fileError }}</li>
              }
            </ul>
          </div>
        </mc-notification>
      </div>
    }

    @if (rowErrors.length > 0) {
      <mc-notification slot="footer" class="result-footer" appearance="error" fit="small" icon="exclamation-circle">
        <div>
          <span>{{ resultSummary }}</span>
          <mc-button
            class="see-details"
            variant="plain"
            appearance="neutral"
            fit="small"
            padding="compact"
            label="See failed details"
            (click)="downloadErrorCsv()"
            (keydown.enter)="downloadErrorCsv()"
            (keydown.space)="$event.preventDefault(); downloadErrorCsv()"></mc-button>
          @if (errorsTruncated) {
            <div class="truncation-note" i18n>Lists the first {{ rowErrors.length }} of {{ failedCount }} failed rows.</div>
          }
        </div>
      </mc-notification>
    }

    <mc-button
      label="Done"
      slot="primaryAction"
      appearance="primary"
      fit="small"
      [loading]="uploading"
      [disabled]="!canSubmit"
      (click)="onUploadClick()"
      (keydown.enter)="onUploadClick()"
      (keydown.space)="$event.preventDefault(); onUploadClick()"></mc-button>
  </mc-modal>
}
